import { IconsContainer, ComplianceIcon } from './styles';
import HIPAACompliantIcon from 'design-system/src/assets/icons/HIPAACompliant.png';
import SOC2Icon from 'design-system/src/assets/icons/SOC2.png';

const CertificationIcons = () => {
  return (
    <IconsContainer>
      <ComplianceIcon src={HIPAACompliantIcon} alt="HIPAA Compliant" />
      <ComplianceIcon src={SOC2Icon} alt="SOC 2 Compliant" />
    </IconsContainer>
  );
};

export default CertificationIcons;
